import Lottie from "lottie-react";
import animationData from "../lotties/beer.json";

const DrinkSpinner = (props) => {
  return (
    <div className="lottie-wrapper">
      <Lottie
        animationData={animationData}
        style={{ objectFit: "cover", height: props.height, width: props.width }}
      />
    </div>
  );
};

export default DrinkSpinner;
